import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BillItemApi } from '../api';

export const findBillItemToExport = createAsyncThunk(
  'billItem/findBillItemToExport',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await BillItemApi.findToExport(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBillItemToUpdateStock = createAsyncThunk(
  'billItem/findBillItemToStock',
  async (param: any, { rejectWithValue }) => {
    try {
      const { id, ...option } = param;
      const response = await BillItemApi.findToUpdateStock(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const billItemSlice = createSlice({
  name: 'billItemMedia',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: billItemReducer } = billItemSlice;

export default billItemReducer;
